import React from "react";
import { BCMSCurrency, DisabledPrompt, Link } from "bcms-react";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRow, FormRowView } from "components/shared";
import ACHTransfersFromTable from "../ACHTransfersFromTable";


import MobileACHTransfersFromTable from "../MobileACHTransfersFromTable";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function ACHTransfersFromSection 
 * @param {STRING} debitAmount - Sets the ACH debit amount text. 
 * @param {STRING} offsetAccount - Sets the ACH offset accounts. 
 * @return {React.Component}
 * @exported true
 * @description The is the one time ACH From section for OneTimeACHPaymentPage
 */
export default function ACHTransfersFromSection(props) {
    const ui = props.ui ?? {};
    const data = props.data ?? {};
    const action = props.action ?? {};
    const onChangeDataProp = action.onChangeDataProp ?? (() => {});
    const offsetAccounts = data.offsetAccounts ?? [];
    const onAddOffsetAccountClick = action.onAddOffsetAccountClick ?? (() => {});
    const onACHFromAccountChange = action.onACHFromAccountChange ?? (() => {});
    const selectedOffsetAccount = data.selectedOffsetAccount.account ?? {};
    const achFromAccounts = data.achFromAccounts ?? [];
    const onACHFromAccountDelete = action.onACHFromAccountDelete ?? (() => {});
    const offsetAccountSelectIsActive = ui.offsetAccountSelectIsActive.isActive ?? false;

    let amount = achFromAccounts.accounts.reduce((acc, item) => {
        const currAmount = item.amount.amount;
        if(currAmount) return acc + parseFloat(currAmount);
        return acc;
    }, 0);
    amount = BCMSCurrency.init(amount);

    const offsetAccountRows = offsetAccounts.reduce((acc, item) => {
        const accountName = `${ item.number } - ${ item.nickname } (Available ${ item.availableBalance.format() })`;
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.id } dataPoint={ `One_Time_ACH_Offset_Account_Option_${ item.id }` }>{ accountName } </CustomSelectItem>
        );
        return acc;
    }, []);

    return (
        <div className="one-time-ach-payment-section one-time-ach-from-section">
            <h2 className="section-title">ACH From</h2>
            <div className="show-on-desktop">
                <ACHTransfersFromTable achFromAccounts={ achFromAccounts } onACHFromAccountChange={ onACHFromAccountChange } 
                onACHFromAccountDelete={ onACHFromAccountDelete } />
            </div>
            <div className="show-on-mobile">
                <MobileACHTransfersFromTable achFromAccounts={ achFromAccounts } onACHFromAccountChange={ onACHFromAccountChange } 
                onACHFromAccountDelete={ onACHFromAccountDelete } />
            </div>
            <FormContainer className="small-form-width">
                <FormRow>
                    <p className="form-detail-row flex-container align-center">
                        <span className="form-detail form-detail-label">Debit Amount</span>
                        <span className="form-detail form-detail-text"> { amount.format() }</span>
                        <SVGAsset id="QuestionMarkCircleIcon" className="question-mark-circle-icon" />
                    </p>
                </FormRow>
                <FormRowView text="* Offset Account">
                    <CustomSelect active={ offsetAccountSelectIsActive } value={ selectedOffsetAccount.id }
                    dataPoint={ `One_Time_ACH_Offset_Account_Select` }
                    onChange={ onChangeDataProp("offsetAccount") }>
                        { offsetAccountRows }
                    </CustomSelect>
                </FormRowView>
                <FormRow>
                    <a className="clickable" onClick={ onAddOffsetAccountClick }>
                        <span data-point={`One_Time_ACH_Add_Account_Link` }>Add Account</span>
                    </a>
                </FormRow>
            </FormContainer>
        </div>
    )
}